<h1 mat-dialog-title>Work Order Crew Override</h1>
<div mat-dialog-content>
  <p>Remove or add field technicians from crew as appropriate for this work order.</p>
  <form #crewForm="ngForm" (ngSubmit)="updateCrew(crewForm)">
    <div class="modal-body">
      <div class="form-group row">
        <div class="col-sm-3">
          <b>Removals</b>
        </div>
        <div class="col-sm-9 input-group">
          <select name="removeSelection" id="removeSelection"
                  [(ngModel)]="removeSelection"
                  class="form-control select-bidit">
            <option *ngFor="let fieldTech of workOrderPersonnel" [ngValue]="fieldTech">{{fieldTech.fieldTechnician_FirstName}} {{fieldTech.fieldTechnician_LastName}}</option>
          </select>
          <div class="input-group-append">
            <button type="button" class="ml-1 btn btn-bidit-action" (click)="removePersonnel()">Remove</button>
          </div>
        </div>

        <div *ngFor="let removal of removals" class="row col-sm-12">
          {{removal.fieldTechnician_FirstName}} {{removal.fieldTechnician_LastName}}
          <button type="button" class="ml-2 btn btn-bidit-delete"
                  title="Cancel removal" (click)="cancelRemoval(removal)"></button>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3">
          <b>Additions</b>
        </div>
        <div class="col-sm-9 input-group">
          <select name="addSelection" id="addSelection"
                  [(ngModel)]="addSelection" 
                  class="form-control select-bidit">
            <option *ngFor="let fieldTech of availablePersonnel" [ngValue]="fieldTech">{{fieldTech.fieldTechnician_FirstName}} {{fieldTech.fieldTechnician_LastName}}</option>
          </select>
          <div class="input-group-append">
            <button type="button" class="ml-1 btn btn-bidit-action" (click)="addPersonnel()">Add</button>
          </div>
        </div>

        <div *ngFor="let addition of additions" class="row col-sm-12">
          {{addition.fieldTechnician_FirstName}} {{addition.fieldTechnician_LastName}}
          <button type="button" class="ml-2 btn btn-bidit-delete"
                  title="Cancel addition"
                  (click)="cancelAddition(addition)"></button>
        </div>
      </div>
    </div>
    <div [hidden]="!crewForm.submitted || crewForm.valid"
         class="alert alert-danger">
      Validation issues encountered.  Please review your entered information.
    </div>
    <div>
      <div *ngIf="!isRequesting">
        <button type="submit" mat-button class="btn btn-bidit-action mr-1">Submit</button>
        <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel">Cancel</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </form>
</div>
